import React, { Suspense, createContext, useContext } from 'react';

import { getDataFetcherForSuspense, type SuspenseableDataFetcher } from './dataFetcherForSuspense';

const SuspenseBoundaryNameContext = createContext<string | null>(null);

export const useSuspenseBoundaryName = (): string | null => {
	return useContext(SuspenseBoundaryNameContext);
};

function SuspenseWithDataFetcherReader({
	dataFetcher,
	children,
}: {
	dataFetcher: SuspenseableDataFetcher | null;
	children: React.ReactNode;
}) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		dataFetcher?.read();
	}
	return <>{children}</>;
}

export function SuspenseWithDataFetcher({
	dataFetcherName,
	fallback = null,
	children,
}: {
	dataFetcherName: string;
	fallback?: React.ReactNode;
	children: React.ReactNode;
}) {
	if (window.__SSR_REACT_STREAMING__) {
		const dataFetcher = getDataFetcherForSuspense(dataFetcherName);
		return (
			<SuspenseBoundaryNameContext.Provider value={dataFetcherName}>
				<Suspense fallback={fallback}>
					<SuspenseWithDataFetcherReader dataFetcher={dataFetcher}>
						{children}
					</SuspenseWithDataFetcherReader>
				</Suspense>
			</SuspenseBoundaryNameContext.Provider>
		);
	} else {
		return <>{children}</>;
	}
}
